import { CrudForm } from '../shared/CrudPage';
import { promotionService } from '@kss/api';
import type { Promotion, PromotionCreate, PromotionFilter } from '@kss/api';
import { loadProductCategoryOptions } from '../../utils/fkLoaders';

type F = {
  code: string;
  name: string;
  description: string;
  status: string;
  remarks: string;
  promotionType: string;
  startDate: string;
  endDate: string;
  budget: number;
  applicableProducts: string;
  isActive: boolean;
};

const empty: F = {
  code: '',
  name: '',
  description: '',
  status: '',
  remarks: '',
  promotionType: 'Flash',
  startDate: '',
  endDate: '',
  budget: 0,
  applicableProducts: '',
  isActive: true,
};

export default function NewPromotion() {
  return (
    <CrudForm<Promotion, PromotionCreate, PromotionFilter, F>
      title="promotion"
      service={promotionService}
      idKey="promotionId"
      basePath="/panel/promotions"
      emptyForm={empty}
      fields={[
        { key: 'code', label: 'Code', required: true },
        { key: 'name', label: 'Name', required: true },
        { key: 'promotionType', label: 'Type', type: 'select', options: [{ value: 'Flash', label: 'Flash sale' }, { value: 'Seasonal', label: 'Seasonal' }, { value: 'BundleDeal', label: 'Bundle deal' }, { value: 'BOGO', label: 'BOGO' }] },
        { key: 'startDate', label: 'Start date' },
        { key: 'endDate', label: 'End date' },
        { key: 'budget', label: 'Budget', type: 'number' },
        { key: 'applicableProducts', label: 'Applicable product category', type: 'search', loadOptions: loadProductCategoryOptions },
        { key: 'description', label: 'Description' },
        { key: 'isActive', label: 'Status', type: 'status' },
      ]}
      fromEntity={(r) => ({
        code: ((r as unknown as Record<string, unknown>).code ?? '') as string,
        name: ((r as unknown as Record<string, unknown>).name ?? '') as string,
        description: ((r as unknown as Record<string, unknown>).description ?? '') as string,
        status: ((r as unknown as Record<string, unknown>).status ?? '') as string,
        remarks: ((r as unknown as Record<string, unknown>).remarks ?? '') as string,
        promotionType: ((r as unknown as Record<string, unknown>).promotionType ?? '') as string,
        startDate: ((r as unknown as Record<string, unknown>).startDate ?? '') as string,
        endDate: ((r as unknown as Record<string, unknown>).endDate ?? '') as string,
        budget: Number((r as unknown as Record<string, unknown>).budget ?? 0),
        applicableProducts: ((r as unknown as Record<string, unknown>).applicableProducts ?? '') as string,
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        promotionId: id,
        code: f.code ? f.code : undefined,
        name: f.name ? f.name : undefined,
        description: f.description ? f.description : undefined,
        status: f.status ? f.status : undefined,
        remarks: f.remarks ? f.remarks : undefined,
        promotionType: f.promotionType ? f.promotionType : undefined,
        startDate: f.startDate ? f.startDate : undefined,
        endDate: f.endDate ? f.endDate : undefined,
        budget: f.budget ? Number(f.budget) : undefined,
        applicableProducts: f.applicableProducts ? f.applicableProducts : undefined,
        isActive: f.isActive,
      } as Promotion)}
      validate={(f) => (!f.name.trim() ? 'Name is required' : null)}
    />
  );
}
